import { keyExistsInBoject } from './key-exists-in-object';

export const getUpdateColorByKey = (obj: Record<string, any>, key: string) => {
  return keyExistsInBoject(obj, key) ? '#FCDA73' : undefined;
};
